import React, { useEffect } from 'react'
import { nanoid } from 'nanoid'

// import { API_BASE_LOCATION } from '../api-client/constants'
import { setToken } from '../helpers'
import UplifterSvg from '../svgs/uplifter'
import styles from '../component-styles/generic-page.module.scss'
import Button from '../components/button'
import { unsubscribeMarketing } from '../api-client/graphql-client'

interface Props {
  match: any
}

export function SetToken({ token }: { token: string }): void {
  setToken(token)
  // @ts-ignore
  if (window.dataLayer && window.dataLayer.push) {
    // @ts-ignore
    window.dataLayer.push({ event: 'user-marketing-optout', token })
  }
}
export default function MarketingOptOut({ match }: Props): React.ReactElement {
  const { userId } = match.params

  useEffect(() => {
    const optout = async () => {
      await unsubscribeMarketing({ uid: userId })
    }
    optout()
  }, [])

  return (
    <div className={styles.ssoWrapperOuter}>
      <section className={styles.ssoWrapper}>
        <UplifterSvg link className={styles.svg} />
        <h2 className={styles.title}>A smarter way to track campaigns</h2>
        <div className={styles.box}>
          <p>
            You have successfully been unsubscribed from product update emails.
          </p>
        </div>
        <Button
          to={{
            pathname: '/login',
            key: nanoid(),
            state: {
              applied: true,
            },
          }}
        >
          Login
        </Button>
      </section>
    </div>
  )
}
